<template>
  <div class="moments-container" ref="MomentsHighLife" id="MomentsHighLife">
    <RibbonTitle title="Momentos High Life"></RibbonTitle>
    <div class="mobile-moments-row">
      <div class="moments_phrase-container">
        <h2>Mixología</h2>
      </div>
    </div>
    <div class="moments_content">
      <div class="moments_text-content">
        <div class="moments-row">
          <div class="moments_phrase-container">
            <h2>Mixología</h2>
          </div>
        </div>
        <div class="videos">
            <div>
              <!--<iframe src="https://www.youtube.com/embed/mCpyFj2b6JA" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
              <div
                :id="`player-0`"
                class="videomoments"
              >
              </div>
                <div class="moments_title-video">
                  <h2>Girl in the moon</h2>
                </div>
            </div>
            <div>
              <!--<iframe src="https://www.youtube.com/embed/t3XNA2QEJqM" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
              <div
                :id="`player-1`"
                class="videomoments"
              >
              </div>
                <div class="moments_title-video">
                  <h2>Refreshing Bubbles</h2>
                </div>
            </div>
            <div>
              <!--<iframe src="https://www.youtube.com/embed/dl7rjR5CSkQ" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
              <div
                :id="`player-2`"
                class="videomoments"
              >
              </div>
                <div class="moments_title-video">
                  <h2>El After Office</h2>
                </div>
            </div>
            <div>
              <!--<iframe src="https://www.youtube.com/embed/ytpaKRoTilg" frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
              <div
                :id="`player-3`"
                class="videomoments"
              >
              </div>
                <div class="moments_title-video">
                  <h2>Verano Highlife</h2>
                </div>
            </div>
        </div>
        <div align="center">
          <!--<iframe src="https://www.youtube.com/embed/Tdo6tGaNa1A" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
              <div
                :id="`player-4`"
                class="videomoments"
              >
              </div>
                  <div class="moments_title-video">
                  <h2>The Everyman</h2>
                </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import millerhighlifelogo from "@/assets/miller-high-life-centered-logo.png";
import millerhighlifephrase from "@/assets/miller-high-logo-phrase.png";
import millerhighlifebottle from "@/assets/MHL_Bottles_Single.png";

//Implementar tag 
import tagFunctions from '../utils/tagFunctions';
//Libreria para implementacion de tags
import YouTubePlayer from 'youtube-player';
//Variables para Implementar tag 
let timer, percent = 0, quartileTime, duration

import { mapActions, mapGetters } from "vuex";

import RibbonTitle from "@/components/RibbonTitle";

export default {
  name: "MomentsHighLife",
  components: {
    RibbonTitle
  },
  computed: {
    ...mapGetters([""])
  },
  data() {
    return {
      millerhighlifelogoImage: millerhighlifelogo,
      millerhighlifephraseImage: millerhighlifephrase,
      millerhighlifebottleImage: millerhighlifebottle,
      player: [
        {  },
        {  },
        {  },
        {  },
        {  }
      ],
      slides: [
        {
          video: 'mCpyFj2b6JA',
          name: 'Girl in the moon',
        },
        {
          video: 't3XNA2QEJqM',
          name: 'Refreshing Bubbles',
        },
        {
          video: 'dl7rjR5CSkQ',
          name: 'El After Office',
        },
        {
          video: 'ytpaKRoTilg',
          name: 'Verano Highlife',
        },
        {
          video: 'Tdo6tGaNa1A',
          name: 'The Everyman',
        }
      ],
    };
  },
  methods: {
    ...mapActions({}),
    /* Funciones de los tag*/
    record(event) {
      let currentTime = Math.round(event.target.getCurrentTime());
      percent = getPercent(event);
      if (currentTime == quartileTime) {
          tagFunctions.evVideoPush(
          event.target.getVideoData().title,
          "Reach",
          "25",
          duration,
          "Moments High Life"
          );
      }
      if (currentTime == 2 * quartileTime) {
        tagFunctions.evVideoPush(
        event.target.getVideoData().title,
        "Reach",
        "50",
        duration,
        "Moments High Life"
        );
      }
      if (currentTime == 3 * quartileTime) {
        tagFunctions.evVideoPush(
        event.target.getVideoData().title,
        "Reach",
        "75",
        duration,
        "Moments High Life"
        );
      }
      if (currentTime == Math.round(event.target.getDuration() * 0.99)) {
        tagFunctions.evVideoPush(
        event.target.getVideoData().title,
        "Reach",
        "100",
        duration,
        "Moments High Life"
        );
      }
      function getPercent(event) {
        return Math.round(
        (event.target.getCurrentTime() / event.target.getDuration()) * 100);
      }
    },
    /* Funciones de los tag*/
    onPlayerStateChange(event) {
      duration = event.target.getDuration();
      quartileTime = Math.round(event.target.getDuration() / 4);
      const getQuartile = () => {
        if (percent <= 25) return 25;
        else if (percent > 25 && percent <= 50) return 50;
        else if (percent > 50 && percent <= 75) return 75;
        else return 100;
      };
      if (event.data == window.YT.PlayerState.PLAYING) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Play", getQuartile(), duration, "Moments High Life")
        timer = setInterval(() => {
        this.record(event);
        }, 1000);
      } else {
        clearInterval(timer);
      }
      if (event.data == window.YT.PlayerState.ENDED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Complete", getQuartile(), duration, "Moments High Life")
      }
      if (event.data == window.YT.PlayerState.PAUSED) {
        tagFunctions.evVideoPush(event.target.getVideoData().title, "Pause", getQuartile(), duration, "Moments High Life")  
      }
    },
  },
  mounted() {
    //Implementar tag de acuerdo a cada video
    this.slides.forEach((element, i) => { this.player[i] = YouTubePlayer(`player-${i}`, {videoId: element.video})
    this.player[i].on('stateChange', this.onPlayerStateChange)});
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/Moments.scss";
</style>

<style scoped>
::v-deep .videomoments {
  width: 400px !important;
  height: 240px !important;
}
@media (min-width: 280px) and (max-width: 600px) {
  ::v-deep .videomoments {
    width: 280px !important;
    height: 215px !important;
  }
}

</style>